const P = "#4F0341";

const ICONS = {
  build: (c) => <><circle cx="12" cy="12" r="5" fill={c} /><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" stroke={P} strokeWidth="1.8" strokeLinecap="round" /><circle cx="12" cy="12" r="1.8" fill="#fff" /></>,
  solve: (c) => <><circle cx="10.5" cy="10.5" r="6" fill={c} /><path d="M15 15l5 5" stroke={P} strokeWidth="2.2" strokeLinecap="round" /><path d="M8.8 9.2a1.8 1.8 0 1 1 2.6 1.6c-.6.3-.9.7-.9 1.3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" fill="none" /><circle cx="10.5" cy="13.6" r=".8" fill="#fff" /></>,
  create: (c) => <><path d="M4 20c1.5-3 3.5-4.2 5.6-3.6" stroke={P} strokeWidth="1.8" strokeLinecap="round" fill="none" /><path d="M9 15l9.5-9.5a2 2 0 0 1 2.8 2.8L11.8 17.8 8.5 18.5Z" fill={c} /><path d="M16.5 7.5l2.8 2.8" stroke="#fff" strokeWidth="1.4" /></>,
  help: (c) => <><path d="M12 20s-7-4.4-7-9.6A3.9 3.9 0 0 1 12 8a3.9 3.9 0 0 1 7 2.4C19 15.6 12 20 12 20Z" fill={c} /><path d="M3 16.5c2.2 0 3.5 1 5 2.5h6" stroke={P} strokeWidth="1.8" strokeLinecap="round" fill="none" /></>,
  lead: (c) => <><path d="M6 21V3.5" stroke={P} strokeWidth="2" strokeLinecap="round" /><path d="M6 4h12l-3 4 3 4H6Z" fill={c} /><circle cx="6" cy="21" r="1.4" fill={P} /></>,
  organise: (c) => <><rect x="5" y="4" width="14" height="17" rx="2.5" fill={c} /><path d="M9 3h6v3H9z" fill={P} /><path d="M8.5 11l1.5 1.5 2.5-3M8.5 16l1.5 1.5 2.5-3M14 11h2M14 16h2" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" /></>,
};

const ENJOY = [
  ["build", "#2F6F73", "Building and fixing things"], ["solve", "#3E6FA3", "Solving puzzles and asking why"], ["create", "#D96A4E", "Creating, drawing and writing"],
  ["help", "#5E8C4F", "Helping and teaching others"], ["lead", "#B7791F", "Leading and starting new things"], ["organise", "#5B6770", "Organising and planning"],
];
const WORK = ["Trying out new ideas", "Staying organised and finishing what you start", "Being around people, or working quietly", "Working well with a team", "Staying steady when things get busy"];

export function ClusterIcon({ name, color, className = "h-7 w-7" }) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true">{ICONS[name](color)}</svg>;
}

export default function Frameworks() {
  return (
    <section className="ds-section bg-ds-creamalt" data-testid="landing-frameworks">
      <div className="container-x">
        <div className="max-w-2xl" data-reveal>
          <p className="eyebrow text-ds-plum">What you'll discover</p>
          <h2 className="ds-h2 mt-3">What you enjoy, and how you like to work.</h2>
          <p className="mt-4 text-[17px] text-ds-inksoft leading-relaxed">Put together, they point to directions worth exploring. Never one "right" answer, just more good possibilities.</p>
        </div>
        <div className="mt-12 grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-7" data-reveal>
            <h3 className="font-display text-2xl font-semibold text-ds-plumdeep">What you enjoy</h3>
            <p className="mt-1 text-[15px] text-ds-inksoft">The kinds of activities that make time fly.</p>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-3">
              {ENJOY.map(([key, color, t], i) => (
                <div key={key} className="rounded-2xl p-4 sm:p-5 transition-transform duration-200 hover:-translate-y-1" style={{ backgroundColor: `${color}1F` }} data-testid={`framework-interest-${i}`}>
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ds-cream"><ClusterIcon name={key} color={color} /></span>
                  <p className="mt-4 font-semibold text-[15px] leading-snug text-ds-ink">{t}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-5 lg:pt-1" data-reveal>
            <h3 className="font-display text-2xl font-semibold text-ds-plumdeep">How you like to work</h3>
            <p className="mt-1 text-[15px] text-ds-inksoft">Everyday habits and styles that are uniquely yours.</p>
            <ul className="mt-6 relative">
              <span className="absolute left-[5px] top-3 bottom-3 border-l-2 border-dotted border-ds-plum/30" aria-hidden="true" />
              {WORK.map((p, i) => (
                <li key={p} className="relative flex items-start gap-4 py-3" data-testid={`framework-personality-${i}`}>
                  <span className="relative mt-1.5 h-3 w-3 shrink-0 rounded-full border-2 border-ds-plum bg-ds-creamalt" />
                  <span className="text-[17px] font-medium text-ds-ink">{p}</span>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-[15px] text-ds-ink leading-relaxed" data-testid="framework-tendencies-line">Described as everyday tendencies and strengths to build on.</p>
            <p className="mt-3 text-xs text-ds-inksoft" data-testid="framework-credit">Inspired by the well-known RIASEC interest model and Big Five personality framework.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
